import { useEffect, useState } from "react";
import "./removeRegion.css";
import Select from "react-select";
import { useDispatch } from "react-redux";
import Alert from "../../components/alert/alert";
import axios from "axios";
import baseConfig from "../../../config/config";
import Reactselect from "react-select";

function RemoveRegion({ handleModal }) {
  const [gpuRegionMap, setGpuRegionMap] = useState({});
  const [gpuOptions, setGpuOptions] = useState([]);
  const [selectedGpu, setSelectedGpu] = useState(null);
  const [regionOptions, setRegionOptions] = useState([]);
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [regionError, setRegionError] = useState("");
  const [deleting, setDeleting] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);

  useEffect(() => {
    async function fetchGpuRegionMap() {
      try {
        const response = await axios.get(
          baseConfig.apiBaseUrl + `/display/RegionsToDelete`,
          {
            headers: {
              "Content-Type": "application/json",
              serviceid: sessionStorage.getItem("userToken"),
            },
          }
        );
        let regions = response.data || [];
        setGpuRegionMap(regions);
        setGpuOptions(
          Object.keys(regions).map((gpu) => ({
            value: gpu,
            label: gpu,
          }))
        );
      } catch (error) {
        console.error("Error fetching GPU-Region map:", error);
      }
    }
    fetchGpuRegionMap();
  }, []);

  useEffect(() => {
    if (selectedGpu && selectedGpu.value) {
      const regions = gpuRegionMap[selectedGpu.value] || [];
      setRegionOptions(
        regions.map((region) => ({
          value: region,
          label: region,
        }))
      );
      setSelectedRegions([]); // Reset regions when GPU changes
      setRegionError("");
    } else {
      setRegionOptions([]);
      setSelectedRegions([]);
    }
  }, [selectedGpu, gpuRegionMap]);

  function showToast(message, status) {
    const toaster = document.createElement("div");
    toaster.className = `toaster ${status}-toaster`;
    toaster.style.position = "fixed";
    toaster.style.top = "5%";
    toaster.style.left = "50%";
    toaster.style.transform = "translateX(-50%)";
    toaster.style.height = "35px";
    toaster.style.maxWidth = "300px";
    toaster.style.zIndex = 1000;
    toaster.innerText = message;
    document.body.appendChild(toaster);
    setTimeout(() => {
      toaster.style.display = "none";
    }, 5000);
  }

  function handleGpuSelect(selected) {
    setSelectedGpu(selected);
    setRegionError("");
  }

  function handleRegionSelect(selected) {
    setSelectedRegions(selected);
    setRegionError(
      selected && selected.length
        ? ""
        : "Please select at least one Region to remove"
    );
  }

  function validate() {
    if (!selectedRegions.length) {
      setRegionError("Please select at least one Region to remove");
      return false;
    }
    return true;
  }

  function handleRemoveRegionClick() {
    if (validate()) setShowConfirmation(true);
  }

  async function confirmRemoveRegion() {
    setDeleting(true);
    const regionToDelete = selectedRegions.map((r) => r.value);
    const postData = {
      GPU_Name: selectedGpu.value,
      RegionNames: regionToDelete,
    };
    let csrfToken=localStorage.getItem("csrfToken")
    try {
      const response = await axios.post(
        baseConfig.apiBaseUrl + `/delete/region`,
        postData,
        {
          headers: {
            "Content-Type": "application/json",
            serviceid: sessionStorage.getItem("userToken"),
            "X-CSRF-Token": csrfToken
          },
          withCredentials: true,
        }
      );
      if (response.status === 200) {
        setDeleting(false);
        showToast("Regions removed successfully", "success");
        window.location.reload();
      } else {
        setDeleting(false);
        showToast("Failed to remove Regions", "danger");
      }
    } catch (error) {
      setDeleting(false);
      showToast("Failed to remove Regions", "danger");
      console.error("Error fetching GPU-Region map:", error);
    }
  }

  const isSubmitDisabled = regionError || deleting || !selectedRegions.length;

  return (
    <>
      <div className="_regionmodal-container-add">
        <div className="_regionfixed-top">
          <div className="_regiontitle-add">
            <b>Remove Regions</b>
            <i className="fa fa-times _regionclose-icon" onClick={handleModal} style={{ cursor: 'pointer' }} />
          </div>
          <hr className="_regiondivider-add" />
          <div className="_regiontitle-disclaimer">
            <b>
            For the selected GPU, the Region dropdown lists only those regions where all GPU-related values (Total, Earmarked, Committed, Allocated and Available) are zero, and the region is not mapped to any existing record.</b>
          </div>
        </div>

        <div className="_regionscrollable-middle">
          <div className="_regiongrid-container-add">
            <div className="_regiongrid-item-add">
              <div className="_regioninput-container-add">
                <label className="_regiontext-container-add">
                  Select GPU <span style={{ color: "red" }}>*</span>
                </label>
                <Reactselect
                  isClearable
                  placeholder="Select GPU..."
                  value={selectedGpu}
                  options={gpuOptions}
                  onChange={handleGpuSelect}
                  classNamePrefix="react-select"
                  isMulti={false}
                />
              </div>
            </div>
            <div className="_regiongrid-item-add">
              <div className="_regioninput-container-add">
                <label className="_regiontext-container-add">
                  Select Regions <span style={{ color: "red" }}>*</span>
                </label>
                <Select
                  isMulti
                  options={regionOptions}
                  onChange={handleRegionSelect}
                  value={selectedRegions}
                  placeholder="Select Regions..."
                  classNamePrefix="_regioncustom-select"
                  menuPortalTarget={document.body}
                  menuShouldBlockScroll
                  isDisabled={!selectedGpu}
                />
                {regionError && (
                  <span
                    style={{
                      color: "red",
                      fontSize: "8px",
                      marginTop: "3px",
                      display: "block",
                    }}
                  >
                    {regionError}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="_regionfixed-bottom">
          <hr className="_regiondivider-add" />
          <div className="_regionbuttons-container-add _regionmarginBottom" style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <button className="_regionbutton-add _regionbutton-go-back-add" onClick={handleModal} style={{ padding: '8px 16px' }}>
              Cancel
            </button>
            <button
              className="_regionbutton-add _regionbutton-confirm-add"
              onClick={handleRemoveRegionClick}
              disabled={isSubmitDisabled}
              style={{ padding: '8px 16px', opacity: isSubmitDisabled ? 0.5 : 1 }}
            >
              Remove Region
            </button>
          </div>
        </div>
      </div>

      {showConfirmation && (
        <>
          <div className="modal-backdrop" style={{ zIndex: "1000" }}></div>
          <Alert
            message={"Are you sure you want to delete these Regions?"}
            SubmitbuttonText={"Delete"}
            deleting={deleting}
            onclickSubmit={confirmRemoveRegion}
            onClickCancel={() => {
              setShowConfirmation(false);
            }}
          ></Alert>
        </>
      )}
    </>
  );
}

export default RemoveRegion;